export default __webpack_public_path__ + "static/media/FotografiaP&B.86a0fb89.jpeg";